// src/app/_service/snackbar.service.ts

import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private messages: MessageService) {}

  show(message: string, severity: 'success' | 'error' | 'warn' | 'warning' | 'info' = 'info', duration: number = 3000) {
    if (severity === 'success') {
      this.showSuccessMessage(message, duration);
      return;
    }

    if (severity === 'error') {
      this.showErrorMessage(message);
      return;
    }

    if (severity === 'warn' || severity === 'warning') {
      this.showWarningMessage(message);
      return;
    }

    this.messages.add({
      key: 'global',
      severity: 'info',
      summary: 'Info',
      detail: message,
      life: duration,
    });
  }

  showSuccessMessage(message: string, duration: number = 3000) {
    console.log('SnackbarService: showSuccessMessage called with message:', message);
                // this.messages.add({
                //     key: 'global',
                //     severity: 'success',
                //     summary: 'Saved',
                //     detail: 'User MONKEYS were successfully saved.',
                //     life: 6000
                // });

    this.messages.add({
      key: 'global',
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: duration,
    });
  }

  showErrorMessage(message: string) {
    console.log('SnackbarService: showErrorMessage called with message:', message);
    this.messages.add({
      key: 'global',
      severity: 'error',
      summary: 'Error',
      detail: message,
      sticky: true, // stays until dismissed
    });
  }

  showWarningMessage(message: string) {
    console.log('SnackbarService: show WarningMessage called with message:', message);
    this.messages.add({
      key: 'global',
      severity: 'warn',
      summary: 'Warning',
      detail: message,
      sticky: true, // stays until dismissed
    });
  }


}